document.addEventListener('DOMContentLoaded', () => {
  // Lenis smooth scroll
  const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
  const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
  requestAnimationFrame(raf);

  // GSAP + ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Revealers
  const reveal = (selector, vars) => {
    gsap.utils.toArray(selector).forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, ...vars.from },
        {
          opacity: 1, ...vars.to,
          scrollTrigger: { trigger: el, start: 'top 85%', once: true }
        }
      );
    });
  };

  reveal('.motion-fadeup', { from:{y:24}, to:{y:0, duration:.6, ease:'power2.out'} });
  reveal('.motion-scale',  { from:{scale:.96}, to:{scale:1, duration:.5, ease:'power2.out'} });
  reveal('.motion-slide-l',{ from:{x:-24}, to:{x:0, duration:.6, ease:'power2.out'} });
  reveal('.motion-slide-r',{ from:{x:24},  to:{x:0, duration:.6, ease:'power2.out'} });

  // Parallax backgrounds
  gsap.utils.toArray('[data-parallax]').forEach(el => {
    const strength = parseFloat(el.dataset.parallax) || 20;
    gsap.to(el, {
      y: () => (ScrollTrigger.maxScroll(window) + window.innerHeight) * (strength/100),
      ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', scrub: true }
    });
  });

  // Sticky counters / metrics (optional)
  gsap.utils.toArray('[data-count]').forEach(el => {
    const target = +el.dataset.count;
    let obj = {val: 0};
    ScrollTrigger.create({
      trigger: el, start: 'top 85%', once: true,
      onEnter: () => gsap.to(obj, {
        val: target, duration: 1, ease: 'power1.out',
        onUpdate: () => el.textContent = Math.round(obj.val)
      })
    });
  });
});
